<!-- <mat-toolbar class="footer-toolbar">
    <button mat-button (click)="goToPage(section)" [class]="getCurrentCss(section)" *ngFor="let section of getCurrentButtons()">
      <span class="nav-cnt">
        <i [class]="section.icon"></i>
        <div class="title">{{section.label}}</div>
      </span>
    </button>
</mat-toolbar> -->

<nav class="nav">
    <div class="nav-item"  (click)="goToPage(section)" data-color="#5b37b7" [class]="getCurrentCss(section)" *ngFor="let section of getCurrentButtons()">
        <div class="nav-cnt"  >
            <i [class]="section.icon"></i>
            <div class="title">{{section.label}}</div>
        </div>
    </div> 
</nav>